import React from 'react';
import styled from 'styled-components';
import { ScrollElement } from 'react-scroll';

const FormContext = React.createContext();

const Button = styled.button`
  text-transform: uppercase;
  font-size: 20px;
  line-height: 34px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  color: #fff;
  border: 0;
  background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  border-radius: 4px;
  box-shadow: 0px 3px 30px rgba(0, 0, 0, 0.16);
  height: 60px;
  width: ${props => (props.theme.isPortrait ? '100%' : '382px')};

  &:hover:not([disabled]) {
    background-color: #9b7e32;
  }

  &[disabled] {
    background-color: #9b7e32;
  }
`;

/* eslint-disable no-nested-ternary */
const Article = ScrollElement(styled.article`
  align-self: center;
  max-width: 1096px;
  width: ${props => (props.theme.isPortrait ? 100 : 76)}vw;
  min-height: ${props => (props.theme.isPortrait
    ? (props.long ? '740px' : '480px')
    : (props.short ? '396px' : '436px'))};
  margin: ${props => (props.theme.isPortrait ? '104px 0 56px 0' : '130px 0 68px 0')};
  padding: ${props => (props.theme.isPortrait ? '0 20px' : '0')};
  border-radius: ${props => (props.theme.isPortrait ? 0 : 10)}px;
  background-color: ${props => props.theme.bodyColor};
  box-shadow: ${props => (props.theme.isPortrait ? 'none' : '0px 3px 50px rgba(4, 36, 95, 0.4)')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  > ${Button} {
    margin-top: 10px;
    margin-bottom: 60px;
  }
  > .loading-panel {
    width: ${props => (props.theme.isPortrait ? '100%' : 'auto')};
    margin-top: ${props => ((props.theme.isPortrait && !props.long) ? 20 : 10)}px;
    margin-bottom: 60px;
  }
`);
/* eslint-enable no-nested-ternary */

const Text = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  color: #fff;
  > em {
    font-style: normal;
    color: ${props => props.theme.primaryColor};
  }
`;

const Title = styled(Text)`
  font-size: ${props => (props.theme.isPortrait ? 25 : 30)}px;
  line-height: ${props => (props.theme.isPortrait ? 25 : 30)}px;
  text-transform: uppercase;
  margin: 0;
  text-align: center;

  &:first-child {
    margin-top: 54px;
  }
`;

const Desc = styled(Text)`
  margin: 0;
  margin-top: ${props => (props.theme.isPortrait ? 30 : 10)}px;
  font-size: 13px;
  line-height: 13px;
  text-align: center;
`;

const HelpBlock = styled.label`
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 13px;
  color: ${props => props.theme.errorColor};
  margin-left: 2px;
`;

const Input = styled.input`
  border-radius: 4px;
  border: 1px solid ${props => props.theme.bodyColor};
  background-color: #1b2c4a;
  height: 50px;
  width: ${props => (props.theme.isPortrait ? '100% !important' : '380px')};
  text-transform: uppercase;
  color: ${props => props.theme.secondaryColor};
  padding-left: 24px;
  font-size: 13px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};

  &:not([data-error="show"]) + ${HelpBlock} {
    display: none;
  }
`;

/* stylelint-disable no-descending-specificity */
/* eslint-disable no-nested-ternary */
const InputContainer = styled.div`
  height: 50px;
  margin: 10px;
  flex-grow: 0;
  flex-shrink: ${props => (props.theme.isPortrait
    ? 0.68
    : (props.size === 'quarter' ? 0.32 : 0.68))};
  flex-basis: ${props => (props.theme.isPortrait
    ? '382px'
    : (props.size === 'quarter' ? '180px' : '382px'))};

  &:nth-child(3) {
    order: ${props => (props.theme.isPortrait ? 4 : 3)};
  }

  &:nth-child(4) {
    order: ${props => (props.theme.isPortrait ? 3 : 4)};
  }

  &:nth-child(n+5) {
    order: 5;
  }

  > ${Input} {
      width: 100%
  }
`;
/* eslint-enable no-nested-ternary */
/* stylelint-enable no-descending-specificity */

const ReflowContainer = styled.div`
  margin-top: ${props => (props.theme.isPortrait ? 36 : 10)}px;
  align-items: center;
  display: flex;
  flex-direction: ${props => (props.theme.isPortrait ? 'row' : 'row')};
  flex-wrap: ${props => (props.theme.isPortrait ? 'wrap' : 'wrap')};
  justify-content: center;
  height: ${props => (props.short ? '154px' : 'auto')};
  max-width: 804px;
  width: 100%;
`;

const Agreement = styled.div`
  margin: ${props => (props.theme.isPortrait ? '10px 0 22px 0' : '28px 10px 10px 10px')};
  flex: 1 1 382px;
  text-align: center;
  order: 50;
  ${props => props.theme.isPortrait && `
    display: flex;
    flex-direction: row;
    text-align: left;
  `};
`;

const Checkbox = styled.input`
  width: 13px;
  height: 13px;
  position: relative;
  top: 2px;
  left: ${props => (props.theme.isPortrait ? 0 : -10)}px;
`;

export {
  Article,
  Agreement,
  Button,
  Checkbox,
  Desc,
  FormContext,
  HelpBlock,
  Input,
  InputContainer,
  ReflowContainer,
  Title,
};
